"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rodengo-saiano": {
    "68381a00": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "chivo": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "baf556dd": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "frella": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "944b3c97": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "moie": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7eb127c5": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "montano": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a3dfe3b5": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "padergnone": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "11789714": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "rodengo": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "248b5938": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "saiano": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9387ab9f": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "san-benedetto": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c3ecd4d": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "060b3a15": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "spissa": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "df840fa1": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "8fb6a699",
      "slug": "rodengo-saiano",
      "name": "Rodengo Saiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;